import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider, hydrate } from '@tanstack/react-query';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

const element = document.getElementById('root')!;
const embedded = document.getElementById('app-state');
const state = embedded ? JSON.parse(embedded.textContent || '{}') : null;
if (state?.queries) hydrate(queryClient, state.queries);
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App notFound={state?.notFound} />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

if (state) ReactDOM.hydrateRoot(element, app);
else ReactDOM.createRoot(element).render(app);
